"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = void 0;
var BACK_TO_PREVIOUS_UI = 'Back to previous ui';
var COLLAPSE_MINOR_VERSION_SECTION = 'Collapse minor version properties section';
var EXPAND_MINOR_VERSION_SECTION = 'Expand minor version properties section';
var EVENT_TYPES = exports.EVENT_TYPES = {
  BACK_TO_PREVIOUS_UI: BACK_TO_PREVIOUS_UI,
  COLLAPSE_MINOR_VERSION_SECTION: COLLAPSE_MINOR_VERSION_SECTION,
  EXPAND_MINOR_VERSION_SECTION: EXPAND_MINOR_VERSION_SECTION
};
//# sourceMappingURL=events.js.map